import { EnvironmentState } from 'store/slices/environment/reducer';

export const ENVIRONMENT: EnvironmentState = {
  NODE_ENV: 'development',
  PUBLIC_URL: '/',
  REACT_APP_BASE_URL: '/',
  REACT_APP_HOST: 'www.tecmasolutions.com',
  REACT_APP_NAME: 'myaccount',
  REACT_APP_WEB_PROTOCOL: 'https://',
  REACT_APP_VERSION: '$npm_package_version',
  REACT_APP_BUCKET_BASEURL: 'https://objectstorage.eu-frankfurt-1.oraclecloud.com/n/fronf8xprl08/b/tecma-assets-coll/o',
  REACT_APP_APOLLO_URI: 'https://api-staging.tecmasolutions.com/biz-tecma-dev1/graphql',
  REACT_APP_API_URI: 'https://api-staging.tecmasolutions.com/biz-tecma-dev1/i18n/v1/labels',
  REACT_APP_NAMESPACE: 'biz-tecma-dev1',
};

export const setEnvironment = (environment: EnvironmentState) => {
  Object.assign(ENVIRONMENT, environment);
};
